import { ChangeEvent } from "react";
import { twMerge } from "tailwind-merge";
import { useDebounce } from "../hooks";
import Icon from "./Icon";
type SearchBoxProps = {
  value?: string | null;
  onSubmit?: (val: string) => void;
};
export default function SearchBox({ value, onSubmit }: SearchBoxProps) {
  const debounce = useDebounce();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value || "";
    debounce(() => onSubmit?.(value));
  };
  return (
    <div
      className={twMerge(
        "w-full flex items-center bg-default-theme gap-2 border border-transparent rounded px-2 py-1 focus-within:border-primary transition-colors",
      )}
    >
      <button type="button">
        <Icon
          name="SearchNormal1"
          variant="Outline"
          size={24}
          className="text-[#A1A4AC]"
        />
      </button>
      <input
        defaultValue={value ?? ""}
        onChange={handleChange}
        placeholder="Search"
        className="flex-1 h-8 px-2 bg-transparent focus:outline-none"
      />
    </div>
  );
}
